import angular from 'angular';

import uiSrefIfDirective from './ui-sref-if-directive';

const uiSrefIf = angular.module('uiSrefIf', []);
uiSrefIf.directive('uiSrefIf', uiSrefIfDirective);

export default uiSrefIf.name;
